import { detectVisibilityPatterns }    from './patterns/visibility';
import { detectDisablePatterns }       from './patterns/disable';
import { detectRequiredPatterns }      from './patterns/required';
import { detectOptionFilter }          from './patterns/optionFilter';
import { detectValidationRules }       from './patterns/validation';
import { detectDatepickerConstraints } from './patterns/datepicker';
import { detectComputedSum }           from './patterns/computedSum';

const DISPATCH_EVENT_PATTERN =
  /window\.dispatchEvent\(\s*new\s+CustomEvent\(\s*["']([^"']+)["']/g;

const FIELD_SELECTOR_PATTERN = /\[id\^=\s*['"]?([\w]+?)_*['"]?\]/g;

export function parseScript(script, ownerFieldKey, allFieldKeys = [], scriptType = 'pre_init') {
  if (!script || !script.trim()) {
    return { effects: [], optionFilter: null, validation: [], dispatchedEvents: [] };
  }

  if (scriptType === 'pre_save') {
    const validation = detectValidationRules(script, ownerFieldKey, allFieldKeys);
    return { effects: [], optionFilter: null, validation, dispatchedEvents: [] };
  }

  const currencyFormatterMaxLength = detectCurrencyFormatterMaxLength(script, ownerFieldKey);

  const computedSum = detectComputedSum(script, ownerFieldKey);

  const effects = [
    ...detectVisibilityPatterns(script, ownerFieldKey),
    ...detectDisablePatterns(script, ownerFieldKey),
    ...detectRequiredPatterns(script, ownerFieldKey),
    ...(computedSum ? [computedSum] : []),
  ];

  const optionFilter = detectOptionFilter(script, ownerFieldKey);
  const validation   = detectDatepickerConstraints(script, ownerFieldKey);
  const dispatchedEvents = extractDispatchedEvents(script);

  if (effects.length === 0 && !optionFilter && validation.length === 0) {
    const isDatepickerOnly = /^[\s\$\(\["'a-z\^=\]_\),\.\s]*datepicker/i.test(script.trim());
    const isSelfFormattingOnly = isCurrencyFormatterTargetingSelfOnly(script, ownerFieldKey);
    if (!isDatepickerOnly && !isSelfFormattingOnly && script.trim().length > 50) {
      console.warn(
        `[FieldEngine] Script parser could not fully convert pre_init_script for "${ownerFieldKey}".`,
        '\nScript (first 200 chars):', script.substring(0, 200)
      );
    }
  }

  return { effects, optionFilter, validation, dispatchedEvents, maxLength: currencyFormatterMaxLength };
}

function isCurrencyFormatterTargetingSelfOnly(script, ownerFieldKey) {
  if (!/currencyFormatter/.test(script)) return false;

  const ownerBase = String(ownerFieldKey ?? '').replace(/_[a-f0-9]{6,}$/i, '');
  const referenced = new Set();
  FIELD_SELECTOR_PATTERN.lastIndex = 0;
  let m;
  while ((m = FIELD_SELECTOR_PATTERN.exec(script)) !== null) {
    referenced.add(m[1]);
  }

  return referenced.size > 0 && [...referenced].every(base => base === ownerBase);
}

function detectCurrencyFormatterMaxLength(script, ownerFieldKey) {
  if (!isCurrencyFormatterTargetingSelfOnly(script, ownerFieldKey)) return null;
  const m = /Num\.length\s*>\s*(\d+)/.exec(script);
  return m ? Number(m[1]) : null;
}

function extractDispatchedEvents(script) {
  const events = [];
  let m;
  DISPATCH_EVENT_PATTERN.lastIndex = 0;
  while ((m = DISPATCH_EVENT_PATTERN.exec(script)) !== null) {
    if (!events.includes(m[1])) events.push(m[1]);
  }
  return events;
}
